import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=006b2878&scoped=true"
var script = {}
import style0 from "./Statement.vue?vue&type=style&index=0&id=006b2878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b2878",
  null
  
)

export default component.exports